<template>
  <div class="toolbar" id="kt_toolbar">
    <div id="kt_toolbar_container" class="container-fluid d-flex flex-stack">
      <div data-kt-swapper="true" data-kt-swapper-mode="prepend"
           data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
           class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
        <h1 class="d-flex text-dark fw-bolder fs-3 align-items-center my-1"> {{ settingText }}</h1>
        <span class="h-20px border-gray-300 border-start mx-4"></span>
        <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
          <div v-for="(bread, key) in breadcrumb" :key="key">
            <div v-if="$can(bread.permission)">
              <li class="breadcrumb-item text-muted" v-if="key + 1 !== breadcrumb.length">
                <router-link 
                  :to="{ name: bread.routeName }" 
                  class="text-muted text-hover-primary"
                  @click.prevent="handleBreadClick(bread)"
                >
                  {{ $t(bread.name) }}
                </router-link>
                <span class="bullet bg-gray-300 w-5px h-2px mx-2"></span>
              </li>
              <li v-else class="breadcrumb-item text-primary">{{ $t(bread.name) }}</li>
            </div>
          </div>
        </ul>
      </div>
      <div class="d-flex align-items-center gap-2 gap-lg-3">
        <div class="m-0">
          <Button v-if="hasBackBtn" icon-class="fas fa-backspace" btn-class="btn-sm" type="cancel" btn-text="back" @click="$router.go(-1)"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import i18n from '@/plugins/i18n';
  import Button from "@/components/Button"
  import {mapGetters} from 'vuex'
  import abilities from "@/composables/abilities";

  export default {
    name: "SettingToolBar",
    components: {Button},
    props: {
      hasBackBtn: { type: Boolean, default: true },
      breadcrumb: { type: Array, default: () => {
        return [
            {routeName:"settings", name:"navigation.setting"},
            {routeName:"settings-company", name:"setting.setting_society", permission: [], routePermission: ''},
            {routeName:"settings-users", name:"setting.setting_user", permission: [], routePermission: ''},
            {routeName:"settings-system-mail", name:"setting.setting_system", permission: [], routePermission: ''},
            {routeName:"settings-finance", name:"setting.expense", permission: [], routePermission: ''}
        ]
      }
      }
    },
      data() {
        return {
          url: window.location.href,
          menuItems: [
            {
              routeName: 'settings-company',
              title: 'setting.companyInformation',
              icon: 'bi bi-circle-square',
              name: "settings-company",
              permission: [],
            },
            {
              routeName: 'settings-departments',
              title: 'setting.departments',
              icon: 'bi bi-patch-check',
              permission: [abilities.VIEW_DEPARTMENT],
              childRouteName:["settings-department-users"],
              name: "settings-company"
            },
            {
              routeName: 'settings-taxes',
              title: 'setting.taxes',
              icon: 'fas fa-check-circle',
              permission: [abilities.VIEW_TAX],
              name: "settings-company"
            },
            {
              routeName: 'settings-post',
              title: 'setting.post',
              icon: 'fas fa-check-circle',
              permission: [abilities.VIEW_POST_OFFICE],
              name: "settings-company"
            },
            {
              routeName: 'settings-rights',
              title: 'setting.right',
              icon: 'bi bi-shield-check',
              childRouteName: [ 'settings-rights-view'],
              permission: [abilities.VIEW_RIGHT],
              name: "settings-users"
            },
            {
              routeName: 'settings-users',
              title: 'setting.users',
              icon: 'fas fa-users',
              childRouteName: [ 'settings-users', 'settings-users-permission-view'],
              permission: [abilities.VIEW_USER],
              name: "settings-users"
            },
            {
              routeName: 'settings-system-mail',
              title: 'setting.system',
              icon: 'bi bi-circle-square',
              permission: [abilities.EMAIL_MESSAGE_VIEW],
              name: "settings-system-mail"
            },
            {
              routeName: 'settings-smtp',
              title: 'setting.smtp',
              icon: 'fas fa-envelope',
              permission: [abilities.EMAIL_CONFIG_VIEW],
              name: "settings-system-mail"
            },
            {
              routeName: 'settings-reminder',
              title: 'setting.reminder_config',
              icon: 'fas fa-bell',
              permission: [abilities.REMIND_CONFIG_VIEW],
              name: "settings-system-mail"
            },
            {
              routeName: 'settings-template',
              title: 'setting.template_config',
              icon: 'fas fa-file-alt',
              permission: [abilities.TEMPLATE_CONFIG_VIEW],
              name: "settings-system-mail"
            },
            {
              routeName: 'settings-payment',
              title: 'setting.payment_mode',
              icon: 'fas fa-ticket-alt',
              permission: [abilities.VIEW_PAYMENT_TYPE],
              name: "settings-system-mail"
            },
            {
              routeName: 'settings-payment_condition',
              title: 'setting.payment_condition',
              icon: 'fas fa-money-check-alt',
              permission: [abilities.VIEW_PAYMENT_CONDITION],
              name: "settings-system-mail"
            },
            {
              routeName: 'settings-reason',
              title: 'setting.reason',
              icon: 'fas fa-money-check-alt',
              name: "settings-reason"
            },
          ]
        };
      },

    computed: {
      ...mapGetters('permission', [
        'permissions'
      ]),
      settingText() {
        const url = window.location.pathname;
        if (url.includes('settings-society')) {
          return i18n.global.t('setting.setting_society');
        }
        if (url.includes('settings-user')) {
          return i18n.global.t('setting.setting_user');
        }

        if (url.includes('settings-system-mail')) {
          return i18n.global.t('setting.setting_system');
        }

        if (url.includes('settings-system')) {
          return i18n.global.t('setting.setting_systeme');
        }
        if (url.includes('settings-finance')) {
          return i18n.global.t('setting.expense');
        }
        if (url.includes('settings-multi-society')) {
          return i18n.global.t('setting.setting_multi_societies');
        }

        return '';
      }
    },
    methods: {
      handleBreadClick(bread) {
        if(this.permissions.includes(bread.routePermission) || bread.routePermission == null){
          this.$router.push({ name: bread.routeName });
        }else{
          let firstPermittedName = bread.permission.find(permission => this.permissions.includes(permission)) || bread.permission.find(permission => permission === null);
          
          let firstPermittedRoute = this.menuItems.filter(item => 
            item.name == bread.routeName && item.permission && item.permission.includes(firstPermittedName)
          )[0];
          if (firstPermittedRoute) {
            this.$router.push({ name: firstPermittedRoute.routeName });
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
